import { render, staticRenderFns } from "./restaurantControl.vue?vue&type=template&id=033dfee7&scoped=true&"
import script from "./restaurantControl.vue?vue&type=script&lang=js&"
export * from "./restaurantControl.vue?vue&type=script&lang=js&"
import style0 from "./restaurantControl.vue?vue&type=style&index=0&id=033dfee7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033dfee7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('033dfee7')) {
      api.createRecord('033dfee7', component.options)
    } else {
      api.reload('033dfee7', component.options)
    }
    module.hot.accept("./restaurantControl.vue?vue&type=template&id=033dfee7&scoped=true&", function () {
      api.rerender('033dfee7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commandCenter/restaurantControl.vue"
export default component.exports